export const PLAYER_HEIGHT = 96;
export const PLAYER_MARGIN = 12;
export const PLAYER_COLLAPSED_ZONE_BASE = PLAYER_HEIGHT + PLAYER_MARGIN;
export const PLAYER_COLLAPSED_ZONE_WHEN_OPEN = PLAYER_COLLAPSED_ZONE_BASE * (2 / 3);
export const PLAYER_COLLAPSED_ZONE_WHEN_COLLAPSED = PLAYER_COLLAPSED_ZONE_BASE * (1 / 3);
export const PLAYER_COLLAPSED_CLOSED_TIMEOUT = 2_000;
export const TOP_SPRING_CONSTANT = 20;
export const BOTTOM_SPRING_CONSTANT = 10;
